import React from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import SendMobile from "./SendMobile";
import SendDesktop from "./SendDesktop";

function Send({ app, config }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  return isMobile ? (
    <SendMobile app={app} config={config} />
  ) : (
    <SendDesktop app={app} config={config} />
  );
}

Send.defaultProps = {
  app: null,
  config: {},
};

Send.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Send;
